"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The RfqSummaryQuery model module.
 * @module model/RfqSummaryQuery
 * @version 0.0.1
 */
var RfqSummaryQuery = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>RfqSummaryQuery</code>.
   * @alias module:model/RfqSummaryQuery
   */
  function RfqSummaryQuery() {
    _classCallCheck(this, RfqSummaryQuery);
    RfqSummaryQuery.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(RfqSummaryQuery, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>RfqSummaryQuery</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RfqSummaryQuery} obj Optional instance to populate.
     * @return {module:model/RfqSummaryQuery} The populated <code>RfqSummaryQuery</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new RfqSummaryQuery();
        if (data.hasOwnProperty('offset')) {
          obj['offset'] = _ApiClient["default"].convertToType(data['offset'], 'Number');
        }
        if (data.hasOwnProperty('limit')) {
          obj['limit'] = _ApiClient["default"].convertToType(data['limit'], 'Number');
        }
        if (data.hasOwnProperty('search')) {
          obj['search'] = _ApiClient["default"].convertToType(data['search'], 'String');
        }
        if (data.hasOwnProperty('opportunity_is_active_only')) {
          obj['opportunity_is_active_only'] = _ApiClient["default"].convertToType(data['opportunity_is_active_only'], 'Boolean');
        }
      }
      return obj;
    }
  }]);
}();
/**
 * @member {Number} offset
 */
RfqSummaryQuery.prototype['offset'] = undefined;

/**
 * @member {Number} limit
 */
RfqSummaryQuery.prototype['limit'] = undefined;

/**
 * @member {String} search
 */
RfqSummaryQuery.prototype['search'] = undefined;

/**
 * @member {Boolean} opportunity_is_active_only
 */
RfqSummaryQuery.prototype['opportunity_is_active_only'] = undefined;
var _default = exports["default"] = RfqSummaryQuery;